import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Home from "./pages/Home";
import Signwriter from "./pages/Signwriter";
import Artist from "./pages/Artist";
import Songwriter from "./pages/Songwriter";
import Musician from "./pages/Musician";
import About from "./pages/About";
import Contact from "./pages/Contact";

import BusinessBranding from "./pages/signwriterPages/BusinessBranding";
import threeDLetteringIlluminated from './pages/signwriterPages/3dLetteringIlluminated';
import CustomArtistic from "./pages/signwriterPages/CustomArtistic";
import ExteriorSigns from "./pages/signwriterPages/ExteriorSigns";
import InteriorSigns from "./pages/signwriterPages/InteriorSigns";
import VehicleSigns from "./pages/signwriterPages/VehicleSigns";
import DesignService from './pages/signwriterPages/DesignService';
import ServiceAreas from './pages/signwriterPages/ServiceAreas';

import { createMuiTheme, ThemeProvider } from '@material-ui/core';

const theme = createMuiTheme(
  {
    typography: {
      fontFamily: [
        'Nunito',
        'sans-serif',
      ].join(','),
      button: {
      textTransform: "none"
      }
    },
  }
);

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path='/signwriter' component={Signwriter} exact/>
        <Route path='/signwriter/business-branding' component={BusinessBranding} exact />
        <Route path='/signwriter/lettering-and-illumination' component={threeDLetteringIlluminated} exact />
        <Route path='/signwriter/custom-artistic' component={CustomArtistic} exact />
        <Route path='/signwriter/exterior' component={ExteriorSigns} exact />
        <Route path='/signwriter/interior' component={InteriorSigns} exact />
        <Route path='/signwriter/vehicle' component={VehicleSigns} exact />
        <Route path='/signwriter/design-service' component={DesignService} exact />
        <Route path='/signwriter/service-areas' component={ServiceAreas} exact />
        <Route path='/artist' component={Artist}/>
        <Route path='/songwriter' component={Songwriter}/>
        <Route path='/musician' component={Musician}/>
        <Route path='/about' component={About}/>
        <Route path='/contact' component={Contact}/>
      </Switch>
    </Router>
  );
}

export default App;
